import React from "react";
import { InputRowGrid } from "../../shared/InputRowGrid";
import TextEditor from "../../shared/TextEditor";
import {
  Box,
  Heading,
  ListItem,
  Stack,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import { AdditionalFilesDropbox } from "./AdditionalFilesDropbox";

export default function JobDescription() {
  return (
    <Stack w="full" gap={{ base: 5, md: 10 }}>
      <InputRowGrid
        heading={
          <Stack mr={1} >
            <Heading
              fontWeight={"semibold"}
              mt={"10px"}
              fontSize={{ base: "20px", xl: "26px" }}
              textAlign={{ base: "start", md: "start" }}
            >
              Description
            </Heading>
            <Box
              color="#676767"
              fontSize={{ base: "14px",lg:"13px", xl: "18px" }}
              pt={{ base: 5, md: 10 }}
              textAlign={{ base: "start", md: "start" }}
            >
              <Text fontWeight="semibold">A good description includes:</Text>
              <UnorderedList fontWeight={400} pt={2}>
                <ListItem>What the deliverable is</ListItem>
                <ListItem>Agency you're looking for</ListItem>
                <ListItem>Anything unique about project</ListItem>
              </UnorderedList>
            </Box>
          </Stack>
        }
        text={"Briefly Describe Your Gig "}
        input={<TextEditor />}
      />
      <InputRowGrid
        heading={
          <Stack >
            <Heading
              fontWeight={"semibold"}
              mt={"10px"}
              fontSize={{ base: "20px", xl: "26px" }}
              textAlign={{ base: "start", md: "start" }}
            >
              Additional Files
            </Heading>
            <Text
              fontWeight={"semibold"}
              fontSize={{ base: "16px", xl: "22px" }}
              textAlign={{ base: "start", md: "start" }}
            >
              (optional)
            </Text>
          </Stack>
        }
        input={<AdditionalFilesDropbox />}
      />
    </Stack>
  );
}
